import React from 'react';
import { Card } from './ui/card';
import { Code, Palette, Database, GitBranch, Layout, Box,Layers,Brain } from 'lucide-react';

const Skills = () => {
  const skillCategories = [
    {
      title: 'Programming',
      icon: Code,
      skills: ['Java','Python', 'JavaScript'],
      color: 'teal',
    },
    {
      title: 'Frontend',
      icon: Palette,
      skills: ['HTML', 'CSS', 'React.js', 'Bootstrap', 'Tailwind CSS'],
      color: 'blue',
    },
    {
      title: 'Backend & Databases',
      icon: Database,
      skills: ['SQL', 'MySQL', 'MongoDB'],
      color: 'purple',
    },
    {
      title: 'Tools & Version Control',
      icon: GitBranch,
      skills: ['Git', 'GitHub'],
      color: 'orange',
    },
    {
      title: 'Concepts',
      icon: Layout,
      skills: ['Responsive Web Design'],
      color: 'green',
    },
    {
      title: 'Libraries',
      icon: Layers,
      skills: ['NumPy', 'Pandas'],
      color: 'cyan',
    },
    {
      title: 'AI & Machine Learning',
      icon: Brain,
      skills: ['Machine Learning Basics', 'Data Preprocessing', 'Model Training'],
      color: 'red',
    },
  ];

  return (
    <section id="skills" className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4">
            Technical <span className="text-teal-500">Skills</span>
          </h2>
          <div className="w-20 h-1 bg-teal-500 mx-auto rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {skillCategories.map((category, index) => {
            const Icon = category.icon;
            return (
              <Card
                key={index}
                className="p-6 bg-white/70 dark:bg-slate-800/70 backdrop-blur-sm border-slate-200 dark:border-slate-700 shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 group animate-in fade-in slide-in-from-bottom"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="p-3 rounded-lg bg-teal-500/10 text-teal-500 group-hover:bg-teal-500 group-hover:text-white transition-colors">
                    <Icon className="h-6 w-6" />
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 dark:text-white">
                    {category.title}
                  </h3>
                </div>

                <div className="flex flex-wrap gap-2">
                  {category.skills.map((skill, skillIndex) => (
                    <span
                      key={skillIndex}
                      className="px-3 py-1 bg-slate-100 dark:bg-slate-700 text-slate-700 dark:text-slate-300 rounded-full text-sm font-medium hover:bg-teal-500 hover:text-white transition-colors"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Skills;
